<template>
  <div ref="container" />
</template>

<script>
export default {
  name: 'StripeElement',
  props: {
    // elements object
    // https://stripe.com/docs/js/elements_object/create
    elements: {
      type: Object,
      required: true
    },
    // type of the element
    // https://stripe.com/docs/js/elements_object/create_element?type=card
    type: {
      type: String,
      default: () => 'card'
    },
    // element options
    // https://stripe.com/docs/js/elements_object/create_element?type=card#elements_create-options
    options: {
      type: [Object, undefined],
      default: () => undefined
    }
  },
  data () {
    return {
      stripeElement: undefined,
      domElement: document.createElement('div')
    }
  },
  computed: {
    elementsUsable () {
      const elms = this.elements
      if (!elms) return false
      return Object.keys(this.elements).length > 0
    }
  },
  methods: {
    createElement () {
      if (typeof this.elements === 'undefined') {
        const errorMsg =
            'Elements object is not defined. You can not create stripe element without it'
        console.error(errorMsg)
        return errorMsg
      }
      if (typeof this.type === 'undefined') {
        const errorMsg =
            'elementType is required. You can not create stripe element without it'
        console.error(errorMsg)
        return errorMsg
      }

      this.stripeElement = this.elements.create(this.type, this.options)
      this.$emit('stripe-element', this.stripeElement)
    },
    mountElement () {
      const domEl = this.domElement
      this.createElement()
      this.stripeElement.mount(domEl)
      this.$refs.container.appendChild(domEl)
      this.$refs.container.firstElementChild.classList.add('w-full')

      return this.stripeElement
    },
    handleEvents () {
      // See stripe element events: https://stripe.com/docs/js/element/events
      const eventTypes = ['change', 'ready', 'focus', 'blur', 'escape']
      eventTypes.forEach((type) => {
        this.stripeElement.on(type, this.eventHandler.bind(this, type))
      })
    },
    eventHandler (type, e) {
      return this.$emit(type, e)
    }
  },
  watch: {
    options: {
      handler (opts) {
        if (opts && this.stripeElement) {
          this.stripeElement.update(opts)
        }
      },
      deep: true
    }
  },
  beforeDestroy () {
    if (this.stripeElement) {
      this.stripeElement.unmount()
      this.stripeElement.destroy()
    }
  },
  mounted () {
    if (this.elementsUsable) {
      this.mountElement()
      this.handleEvents()
    }
  }
}
</script>